// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.general-logo{width:100%}.general-logo--center{text-align:center}.general-logo--left{text-align:left}.general-logo--right{text-align:right}`, "",{"version":3,"sources":["webpack://./src/components/ui/Logo/Logo.scss"],"names":[],"mappings":"AAAA,cACI,UAAA,CAEA,sBACI,iBAAA,CAGJ,oBACI,eAAA,CAGJ,qBACI,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
